import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    ViewEncapsulation
} from '@angular/core';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { CalendarDayBase } from '../../classes/calendar-day-base';
import { DateUtils } from '@flipto/shared/src/lib/utils/common/time/date-utils';
import { isRangeDateIncludes } from '../../utils';
import { SelectMode } from 'apps/account/src/account-shared/modules/monthly-daterange-picker/enums/select-mode.enum';

@Component({
    selector: 'ft-monthly-daterange-day',
    templateUrl: './monthly-daterange-day.component.html',
    styleUrls: ['./monthly-daterange-day.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MonthlyDaterangeDayComponent extends CalendarDayBase<NgbDate> implements OnChanges {
    @Output() reset = new EventEmitter<Event>();
    @Input() disabled: boolean;
    @Input() inactive: boolean;
    @Input() dayRef: NgbDate;
    @Input() availableDayRanges: number[];
    @Input() selectMode: SelectMode;

    selectModeEnum = SelectMode;

    constructor(private cdr: ChangeDetectorRef) {
        super();
    }

    dateRefToDate(dateRef: NgbDate): Date {
        return DateUtils.ngbDateToDate(this.dateRef);
    }

    ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);

        if ((changes.hoveredDate || changes.hoveredMonth) && (this.selectMode != SelectMode.Month)) {
            this.setRangeFlags();
        }

        if ((this.selectMode == SelectMode.Month) || (changes.selectMode?.currentValue == SelectMode.Month)) {
            this.setMonthRangeFlags();
            this.cdr.detectChanges();
        }

        if ((this.selectMode == SelectMode.Month) && changes.hoveredDate) {
            this.setHoveredRangeFlags();
        }

        if (changes.startDate) {
            this.setBaseFlags();

            if (!changes.startDate.isFirstChange() && (this.selectMode != SelectMode.Month)) {
                this.setRangeFlags();
            }
        }

        this.cdr.detectChanges();
    }

    isStatic() {
        if (!this.disabled && !this.isInactive() && this.startDate && !DateUtils.isSame(this.startDate, this.date) && this.availableDayRanges?.length) {
            return !isRangeDateIncludes(this.availableDayRanges, this.startDate, this.date);
        }
        return super.isStatic();
    }

    isInactive() {
        return !!this.inactive;
    }

    isSuggested() {
        return this.availableDayRanges?.length && this.isAvailable() && !this.isStatic() && !this.isInactive() && !this.disabled && this.startDate && !this.endDate;
    }
}
